/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoogleAnalyticsVisibleColumnsQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type GoogleAnalyticsVisibleColumnsQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly googleAnalyticsVisibleColumns: ReadonlyArray<GraphQL.GoogleAnalyticsVersion> } | null };


export const GoogleAnalyticsVisibleColumnsDocument = gql`
    query GoogleAnalyticsVisibleColumns($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    googleAnalyticsVisibleColumns
  }
}
    `;

/**
 * __useGoogleAnalyticsVisibleColumnsQuery__
 *
 * To run a query within a React component, call `useGoogleAnalyticsVisibleColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleAnalyticsVisibleColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleAnalyticsVisibleColumnsQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useGoogleAnalyticsVisibleColumnsQuery(baseOptions: Apollo.QueryHookOptions<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables> & ({ variables: GoogleAnalyticsVisibleColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>(GoogleAnalyticsVisibleColumnsDocument, options);
      }
export function useGoogleAnalyticsVisibleColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>(GoogleAnalyticsVisibleColumnsDocument, options);
        }
export function useGoogleAnalyticsVisibleColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>(GoogleAnalyticsVisibleColumnsDocument, options);
        }
export type GoogleAnalyticsVisibleColumnsQueryHookResult = ReturnType<typeof useGoogleAnalyticsVisibleColumnsQuery>;
export type GoogleAnalyticsVisibleColumnsLazyQueryHookResult = ReturnType<typeof useGoogleAnalyticsVisibleColumnsLazyQuery>;
export type GoogleAnalyticsVisibleColumnsSuspenseQueryHookResult = ReturnType<typeof useGoogleAnalyticsVisibleColumnsSuspenseQuery>;
export type GoogleAnalyticsVisibleColumnsQueryResult = Apollo.QueryResult<GoogleAnalyticsVisibleColumnsQuery, GoogleAnalyticsVisibleColumnsQueryVariables>;